import { render, staticRenderFns } from "./AdminBannerMedias.vue?vue&type=template&id=4a9dd480&"
import script from "./AdminBannerMedias.vue?vue&type=script&lang=js&"
export * from "./AdminBannerMedias.vue?vue&type=script&lang=js&"
import style0 from "./AdminBannerMedias.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9dd480')) {
      api.createRecord('4a9dd480', component.options)
    } else {
      api.reload('4a9dd480', component.options)
    }
    module.hot.accept("./AdminBannerMedias.vue?vue&type=template&id=4a9dd480&", function () {
      api.rerender('4a9dd480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminBannerMedias.vue"
export default component.exports